<template>
    <div style="border:1px solid #e9eaec;width:100%;border-radius: 4px">
        <h4 v-if="title" style="padding:16px;border-bottom: 1px solid #e9eaec">{{title}}</h4>
        <div class="stepsTag" v-if="current>0 ">
            <div v-for="(item,index) in barData" :style="{width:100/barData.length+'%'}" class="mark green red" @click="stepClick(index)">
                <div class="tagTip" v-if="current>index+1">
                    <p class="p1 p2" :style="{visibility:index+1==1?'hidden':'visible'}"></p>
                    <div class="box1" v-if="item.type==='default'">
                        <span>{{index+1}}</span>
                    </div>
                    <div v-else-if="item.type==='process'" class="box have">
                        <span>{{index+1}}</span>
                    </div>
                    <div class="box" v-else>
                        <Icon v-if="item.type==='error'" type="close-circled" style="font-size:35px;color:#e9666b" />
                        <Icon v-else type="ios-checkmark" style="font-size:35px;color:#63DE8B" />
                    </div>
                    <p class="p1 p2" :style="{visibility:index+1 === barData.length?'hidden':'visible'}"></p>
                </div>
                <div class="tagTip" v-else-if="current===index+1">
                    <p :class="{p1:true, p2:index+1!==1}" v-if="current!==1"></p>
                    <p class="p1 p2" v-if="current===1" :style="{visibility:'hidden'}"></p>
                    <div v-if="item.type==='error'" class="box">
                        <Icon type="close-circled" style="font-size:35px;color:#e9666b" />
                    </div>
                    <div class="box1" v-if="item.type==='default'">
                        <span>{{index+1}}</span>
                    </div>
                    <div v-else-if="item.type==='process'" class="box have">
                        <span>{{index+1}}</span>
                    </div>
                    <div v-if="!item.type&& current!==barData.length" class="box have">
                        <span>{{index+1}}</span>
                    </div>
                    <div v-if="!item.type && current===barData.length" class="box">
                        <Icon type="ios-checkmark" style="font-size:35px;color:#63DE8B" />
                    </div>
                    <p class="p1" :style="{visibility:barData.length===index+1?'hidden':'visible'}"></p>
                </div>
                <div class="tagTip" v-else-if="current<index+1">
                    <p class="p1"></p>
                    <div class="box1">
                        <span>{{index+1}}</span>
                    </div>
                    <p class="p1" :style="{visibility:barData.length==index+1?'hidden':'visible'}"></p>
                </div>
                <div v-if="current>index+1">
                    <h4 v-if="!item.type" style="color:#5bd883">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="item.type==='error'" style="color:#e9666b">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="item.type==='default'" style="color:#999">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="item.type==='process'" style="color:#378ff7">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                </div>
                <div v-if="current<index+1">
                    <h4 style="color:#999">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                </div>
                <div v-if="current===index+1">
                    <h4 v-if="item.type==='error'" style="color:#e9666b">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="item.type==='default'" style="color:#999">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="!item.type && current!==barData.length" style="color:#378ff7">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="item.type==='process'" style="color:#378ff7">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                    <h4 v-if="!item.type && current===barData.length " style="color:#5bd883">
                        {{item.title}}
                        <br>
                        <Tooltip :content="item.subTitleTooltip" v-if="item.subTitle">
                            <span class="subTitle" v-if="item.subTitle">{{item.subTitle}}</span>
                        </Tooltip>
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},

    props: {
        current: {
            type: Number,
            default (num) {
                return 1;
            }
        },
        barData: {
            type: Array,
            default () {
                return [];
            }
        },
        title: {
            type: String
        }

    },
    data() {
        return {};
    },
    created() {},
    methods: {
        stepClick(index) {
            this.$emit('stepClick', index);
        }
    }
};

</script>
<style scoped>
.stepsTag {
    /* margin: 20px auto 10px auto; */
    overflow: hidden;
    background: #fff;
    padding: 20px 0px 20px 0px;
}

.mark {
    float: left;
    background: #fff;
    align-items: center;
    padding: 0;
}

.mark h4 {
    text-align: center;
    font-weight: normal;
    padding: 5px;
    font-size: 14px;
}

.mark h4 .subTitle {
    font-size: 12px;
}

.tagTip {
    width: 100%;
    display: flex;
    align-items: center;
}

.green div .p2 {
    border-bottom: 2px solid #44c96f;
}

.green div .box1 {
    background: #e1e3e8;
    /* 标准的语法 */
}

.green .tagTip .have {
    background: #5ba6ff;
    color: #999;
    /* 标准的语法 */
}

.green .tagTip .have {
    color: #fff;
}

.box {
    width: 30px;
    height: 30px;
    line-height: 30px;
    vertical-align: middle;
    border-radius: 100%;
    text-align: center;
    font-size: 14px;
    font-weight: bolder;
    margin-bottom: 3px;
}

.box1 {
    width: 30px;
    height: 30px;
    line-height: 30px;
    vertical-align: middle;
    border-radius: 100%;
    text-align: center;
    font-size: 14px;
    font-weight: bolder;
    color: #999;
    margin-bottom: 3px;
}

.p1 {
    border-bottom: 2px solid #F2F2F2;
    width: 100%;
    height: 0px;
    flex: 1;
}

</style>
